import { render, staticRenderFns } from "./woodDetail.vue?vue&type=template&id=dd836438&scoped=true&"
import script from "./woodDetail.vue?vue&type=script&lang=js&"
export * from "./woodDetail.vue?vue&type=script&lang=js&"
import style0 from "./woodDetail.vue?vue&type=style&index=0&id=dd836438&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd836438",
  null
  
)

export default component.exports